import React from "react";
import ReactDOM from "react-dom/client";
// import reportWebVitals from './reportWebVitals';
import { Toaster } from "sonner";

import App from "./App";
import "./global.scss";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
const queryClient = new QueryClient({});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
	<React.StrictMode>
		<QueryClientProvider client={queryClient}>
			<App />
			{process.env.REACT_APP_SHOW_DEBUG_BAR === "true" && (
				<ReactQueryDevtools initialIsOpen={false} />
			)}
			<Toaster position="top-right" richColors />
		</QueryClientProvider>
	</React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
